// DirectInflowsForm.jsx
import { useState, useEffect } from "react"
import { UniversalDropDown } from "@fileops/swmm-react"
import { Button } from '@mui/material'
import "../../css/DemoCode.css"

/**
 * Direct Inflows Form is a group of data inputs usually shown when clicking on Node->Inflows. 
 * This form is contained within InflowsDialog.
 * 
 * @param {JSON} model A SWMM model in JSON format. In most cases this
 * is a 'submodel' containing only a copy of the affected sections. Using a copy allows
 * for continuous react-style editing without forcing the model to run on every keystroke.
 * @param {function} setModel Update function for updating 'model'.
 * @param {JSON} fullModel The 'full' SWMM model that contains supporting data for this component.
 * @param {string} target The name of the node targetted by this form.
 * @returns UI for interactive swmm modeling.
 */
export default function DirectInflowsForm({model, setModel, fullModel, target}) {
  const [constituent, setConstituent] = useState('FLOW')
  const [constituents]                = useState(["FLOW", ...(Object.keys(fullModel.POLLUTANTS).length===0?[]:Object.keys(fullModel.POLLUTANTS))])
  const [patterns]                    = useState([        ...(Object.keys(fullModel.PATTERNS  ).length===0?[]:Object.keys(fullModel.PATTERNS  ))])
  const [timeSeriesSet]               = useState([        ...(Object.keys(fullModel.TIMESERIES).length===0?[]:Object.keys(fullModel.TIMESERIES))])

  useEffect(()=>{
    // If there is no INFLOW record for this constituent, for this target, create one
    if(model && model.INFLOWS){
      if(!(constituent in model.INFLOWS[target])){
        setModel(prev => ({
          ...prev,
          INFLOWS:{
            ...prev.INFLOWS,
            [target]: {
              ...prev.INFLOWS[target],
              [constituent]: {
                Timeseries: '',
                Type: 'CONCEN',
                UnitsFactor: "1",
                ScaleFactor: "1",
                Baseline: "0",
                Pattern: ''
              }
            }
          }
        }))
      }
    }
  }, )

  // When there is a change to an input element, modify the model.
  const updateValue = (val, type) => {
    // Don't let any undefined updates go through.
    if(val === undefined) val = ""

    if(model && model.INFLOWS){
      setModel(prev => ({
        ...prev,
        INFLOWS:{
          ...prev.INFLOWS,
          [target]: {
            ...prev.INFLOWS[target],
            [constituent]: {
              ...prev.INFLOWS[target][constituent],
              [type]: val
            }
          }
        }
      }))
    }
  }

  return(
    <>
    {
      <>
        {(
          target && 
          target.length > 0 && 
          <label className='editor-small' >Constituent
            <UniversalDropDown style={{padding: '0'}}
              IDs={constituents} 
              selectText={"Select a Constituent"} 
              value={constituent}
              onChange={(val)=>{setConstituent(val)}} >
            </UniversalDropDown>
          </label>
        )}
        {(
          target && 
          target.length > 0 && 
          model.INFLOWS &&
          model.INFLOWS[target] &&
          model.INFLOWS[target][constituent] &&
          <label className='editor-small' >Baseline
            <input  type = "text"
                    style={{width: '95%', display: 'flex'}}
                    onChange={(e)=>{updateValue(e.target.value, 'Baseline')}}
                    value={model.INFLOWS[target][constituent].Baseline}
                    id={'Baseline_'+target}
            />
          </label>
        )}
        {(
          target && 
          target.length > 0 && 
          model.INFLOWS &&
          model.INFLOWS[target] &&
          model.INFLOWS[target][constituent] &&
          <label className='editor-small' >Baseline Pattern
            <Button style={{padding: '0px', float:'right', display:'inline' }}  onClick={()=>{updateValue('', 'Pattern')}}>CLEAR</Button>
            <UniversalDropDown style={{padding: '0'}}
              IDs={patterns} 
              selectText={"Select a Baseline Pattern"} 
              value={model.INFLOWS[target][constituent].Pattern}
              onChange={(val)=>{updateValue(val, 'Pattern')}} >
            </UniversalDropDown>
          </label>
        )}
        {(
          target && 
          target.length > 0 && 
          model.INFLOWS &&
          model.INFLOWS[target] &&
          model.INFLOWS[target][constituent] &&
          <label className='editor-small' >Time Series
          <Button style={{padding: '0px', float:'right', display:'inline' }} onClick={()=>{updateValue('', 'Timeseries')}}>CLEAR</Button>
            <UniversalDropDown style={{padding: '0'}}
              IDs={timeSeriesSet} 
              selectText={"Select a Time Series"} 
              value={model.INFLOWS[target][constituent].Timeseries}
              onChange={(val)=>{updateValue(val, 'Timeseries')}} >
            </UniversalDropDown>
          </label>
        )}
        {(
          target && 
          target.length > 0 && 
          model.INFLOWS &&
          model.INFLOWS[target] &&
          model.INFLOWS[target][constituent] &&
          <label className='editor-small' >Scale Factor
            <input  type = "text"
                    style={{width: '95%', display: 'flex'}}
                    onChange={(e)=>{updateValue(e.target.value, 'ScaleFactor')}}
                    value={model.INFLOWS[target][constituent].ScaleFactor}
                    id={'ScaleFactor_'+target}
            />
          </label>
        )}
      </>
    }
    </>
  )
} 